import React from 'react';
import { Helmet } from 'react-helmet-async';
import { HelmetProvider } from 'react-helmet-async';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { FeaturedCompanions } from './components/FeaturedCompanions';
import { WhyChooseUs } from './components/WhyChooseUs';
import { MembershipSection } from './components/MembershipSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ContactSection } from './components/ContactSection';
import { SeoContentSection } from './components/SeoContentSection';
import { Footer } from './components/Footer';
export function App() {
  return <HelmetProvider data-id="element-0">
      <Helmet data-id="element-1">
        <html lang="zh-CN" data-id="element-2" />
        <title data-id="element-3">SGLonelyGuy | 新加坡寂寞男人 — 新加坡高端伴游服务平台</title>
        <meta name="description" content="新加坡寂寞男人网（SGLonelyGuy）是新加坡本地领先的高端伴游服务平台。提供VIP私人伴游、社交场合陪伴、商务旅行伴侣及定制专属体验。严格审核认证，100%隐私保护，24/7专属客服。新加坡伴游首选平台，服务覆盖乌节路、滨海湾、圣淘沙、芽笼等核心区域。" data-id="element-4" />
        <meta name="keywords" content="新加坡寂寞男人, 新加坡寂寞男人网, SGLonelyGuy, 新加坡伴游, 新加坡高端伴游, VIP伴游服务, 新加坡私人伴游, 新加坡商务伴游, 新加坡社交陪伴, Singapore escort, Singapore companion service, 新加坡夜生活, 芽笼, Geylang, 乌节路伴游, 滨海湾伴游, 圣淘沙伴游, 新加坡约会, 新加坡陪伴服务, 高端社交平台, 新加坡成人服务" data-id="element-5" />
        <meta name="author" content="SGLonelyGuy" data-id="element-6" />
        <meta name="robots" content="index, follow" data-id="element-7" />
        <link rel="canonical" href="https://geylang777-6.site/" data-id="element-8" />

        {/* Open Graph */}
        <meta property="og:type" content="website" data-id="element-9" />
        <meta property="og:title" content="SGLonelyGuy | 新加坡高端伴游服务平台" data-id="element-10" />
        <meta property="og:description" content="新加坡寂寞男人网 — 为都市精英打造的私密伴游体验。500+认证伴游，严格审核、隐私保障、24/7专属客服。新加坡首选高端伴游服务平台。" data-id="element-11" />
        <meta property="og:url" content="https://geylang777-6.site/" data-id="element-12" />
        <meta property="og:site_name" content="SGLonelyGuy 新加坡寂寞男人" data-id="element-13" />
        <meta property="og:locale" content="zh_CN" data-id="element-14" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" data-id="element-15" />
        <meta name="twitter:title" content="SGLonelyGuy | 新加坡高端伴游服务平台" data-id="element-16" />
        <meta name="twitter:description" content="为都市精英打造的私密伴游体验。500+认证伴游，100%隐私保护。" data-id="element-17" />

        {/* Additional SEO */}
        <meta name="theme-color" content="#0a0a0a" data-id="element-18" />
        <meta name="mobile-web-app-capable" content="yes" data-id="element-19" />
        <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" data-id="element-20" />
      </Helmet>

      <div className="min-h-screen bg-dark-bg text-gray-200 font-sans selection:bg-gold-500 selection:text-black" data-id="element-21">
        <HeroSection data-id="element-22" />
        <AboutSection data-id="element-23" />
        <ServicesSection data-id="element-24" />
        <FeaturedCompanions data-id="element-25" />
        <WhyChooseUs data-id="element-26" />
        <MembershipSection data-id="element-27" />
        <TestimonialsSection data-id="element-28" />
        <ContactSection data-id="element-29" />
        <SeoContentSection data-id="element-30" />
        <Footer data-id="element-31" />
      </div>
    </HelmetProvider>;
}